import React from 'react';

export const ClickableRow = ({ item, onRowClick, children }) => (
    <tr onClick={onRowClick && onRowClick(item)}>
        {children}
    </tr>
)
